// Optional Azure AD imports - only load if package is installed
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let PublicClientApplication: any = null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let msalInstance: any = null;

try {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const msalBrowser = require('@azure/msal-browser');
  PublicClientApplication = msalBrowser.PublicClientApplication;
} catch (error) {
  // Package not installed, Azure AD will be unavailable
  console.warn('@azure/msal-browser not installed. Azure AD authentication will be unavailable.');
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMsalInstance = (): any => {
  if (!PublicClientApplication) {
    throw new Error('Azure AD is not available. Please install @azure/msal-browser package.');
  }

  if (!msalInstance) {
    const clientId = process.env.REACT_APP_AZURE_AD_CLIENT_ID;
    const tenantId = process.env.REACT_APP_AZURE_AD_TENANT_ID;

    if (!clientId || !tenantId) {
      throw new Error(
        'Azure AD configuration is missing. Please set REACT_APP_AZURE_AD_CLIENT_ID and REACT_APP_AZURE_AD_TENANT_ID',
      );
    }

    const msalConfig = {
      auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: window.location.origin,
      },
    };

    msalInstance = new PublicClientApplication(msalConfig);
  }

  return msalInstance;
};

export const loginWithAzureAD = async (): Promise<string> => {
  const msal = getMsalInstance();

  // Initialize MSAL if not already done
  await msal.initialize();

  const loginRequest = {
    scopes: ['openid', 'profile', 'email'],
  };

  try {
    const response = await msal.loginPopup(loginRequest);

    if (!response.idToken) {
      throw new Error('No ID token received from Azure AD');
    }

    return response.idToken;
  } catch (error) {
    console.error('Azure AD login failed:', error);
    throw error;
  }
};

export const getAzureADTokenSilently = async (): Promise<string | null> => {
  const msal = getMsalInstance();

  await msal.initialize();

  const accounts = msal.getAllAccounts();
  if (accounts.length === 0) {
    return null;
  }

  const silentRequest = {
    scopes: ['openid', 'profile', 'email'],
    account: accounts[0],
  };

  try {
    const response = await msal.acquireTokenSilent(silentRequest);
    return response.idToken || null;
  } catch (error) {
    // Fallback to popup if silent fails
    try {
      const response = await msal.acquireTokenPopup(silentRequest);
      return response.idToken || null;
    } catch (popupError) {
      console.error('Failed to acquire Azure AD token:', popupError);
      return null;
    }
  }
};

export const logoutAzureAD = async (): Promise<void> => {
  const msal = getMsalInstance();
  await msal.initialize();

  const accounts = msal.getAllAccounts();
  if (accounts.length > 0) {
    await msal.logoutPopup({
      account: accounts[0],
    });
  }
};
